import { Playground } from '../../../components/playground/Playground';
import { Headline } from '../../../components/Headline';
import { Title } from '../../../components/Title';

import { icons, getIconNames, getRandomIcon } from '../../../utils/icons';
import { colors, getColorNames } from '../../../utils/colors';
import { sizes, getSizeClasses } from '../../../utils/sizes';

const humanIcons = [...getIconNames(icons.humans)] as string[];

const eachColor = getColorNames(colors.brand, colors.status) as string[];
const eachTextSize = getSizeClasses(sizes.text) as string[];

export const Icon = () => (
    <div className='uikit-icons'>
        <Headline anchor='uikit-icon'>UIKIT icon</Headline>
        <Playground example={iconIconsExample} />
    </div>
);

const iconIconsExample = (
    <div className='display-flex flex-wrap gap-50'>
        <div>
            <Title>Default</Title>
            <div className='display-flex flex-wrap gap-10'>
                {humanIcons.map(icon => (
                    <span className={`uikit-icon ${icon} text-size-h1`} key={icon} />
                ))}
            </div>
        </div>
        <div>
            <Title>Sized icons</Title>
            <div className='display-flex flex-wrap gap-10'>
                {eachTextSize.map(size => (
                    <span className={`uikit-icon icon-user ${size}`} key={size} />
                ))}
            </div>
        </div>
        <div>
            <Title>Colored icons</Title>
            <div className='display-flex flex-wrap gap-10'>
                {eachColor.map(color => (
                    <span className={`uikit-icon ${getRandomIcon()} text-color-${color} text-size-h1`} key={color} />
                ))}
            </div>
        </div>
    </div>
);
